import Loader from "../../DomUtilities/Loader";
import openErrorModal from "../../Error/ErrorModal";
import { fetchOrderStatusTrackLogModal } from "../../HTTPRequests/OrderRequests";
import { DateTime } from 'luxon';

export default class OrderOverviewModalsHandler {
	modalDiv: HTMLDivElement;
	isInfoModalOpen: boolean;
	orderStatusLogModal: HTMLDivElement;
	id: string;

	constructor(orderId: string, modalDiv: HTMLDivElement) {
		this.modalDiv = modalDiv;
		this.isInfoModalOpen = false;
		this.id = orderId;

		this.addInfoIconsClickListeners();
	}

	private addInfoIconsClickListeners() {
		const infoIcons: NodeListOf<HTMLImageElement> = this.modalDiv.querySelectorAll('img[alt="info icon"]');
		infoIcons.forEach(infoIcon => {
			infoIcon.onclick = () => {
				if (infoIcon.dataset.serviceId) {
					this.openCanvasModal(infoIcon);
				} else {
					this.openOrderStatusModal();
				}
			}
		});
	}

	private openCanvasModal(infoIcon: HTMLImageElement) {
		const modal: HTMLDivElement = this.modalDiv.querySelector(`.service${infoIcon.dataset.serviceId}`);
		modal.style.display = "flex";
		this.isInfoModalOpen = true;
		this.addInfoModalClickListeners(modal, this.modalDiv.firstElementChild);
	}

	private fetchOrderStatusModal() {
		Loader.show();
		fetchOrderStatusTrackLogModal(this.id)
			.then((response: string) => {
				this.orderStatusModalInit(response);
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				Loader.hide();
			});
	}

	private orderStatusModalInit(modalHTMLString: string) {
		this.orderStatusLogModal = document.createElement("div");
		this.orderStatusLogModal.id = 'order-track-log-modal';
		this.orderStatusLogModal.innerHTML = modalHTMLString;
		this.modalDiv.appendChild(this.orderStatusLogModal);
		this.openOrderStatusModal();
		this.updateScanDateFields();
	}

	private openOrderStatusModal() {
		if (this.orderStatusLogModal) {
			this.orderStatusLogModal.style.display = "flex";
			this.isInfoModalOpen = true;
			this.addInfoModalClickListeners(this.orderStatusLogModal, this.orderStatusLogModal.firstElementChild);
		} else {
			this.fetchOrderStatusModal();
		}
	}

	private updateScanDateFields() {
		const orderStatusLogModalRows: NodeListOf<HTMLTableRowElement> = this.orderStatusLogModal.querySelectorAll("table > tbody > tr");
		const lang: string = (this.orderStatusLogModal.firstElementChild as HTMLDivElement).dataset.lang;

		for (let i = 1; i < orderStatusLogModalRows.length; i++) {
			const trackLog: HTMLTableCellElement = orderStatusLogModalRows[i].querySelector(":scope > td:nth-child(2)");
			trackLog.innerHTML = DateTime.fromISO(trackLog.innerText).setLocale(lang).toLocaleString(DateTime.DATETIME_SHORT);
		}
	}

	private addInfoModalClickListeners(modal: HTMLDivElement, eventNode: Node) {
		document.body.onclick = (event) => {
			const isClickOutsideModal = event.target === modal || event.target === eventNode;
			if (this.isInfoModalOpen && isClickOutsideModal) {
				modal.style.display = "none";
				this.isInfoModalOpen = false;
				event.stopPropagation();
			}
		}

		const closeIcon: HTMLImageElement = modal.querySelector('img[alt="close icon"]');
		closeIcon.onclick = (event) => {
			modal.style.display = "none";
			this.isInfoModalOpen = false;
			event.stopPropagation();
		}
	}
}